const ambassadors = {
  name: 'Ambassador',
};

export default ambassadors;
